import { PreauthButtonRenderer } from './PreauthButton';

// Initialize the Preauth button on register page load
if (typeof history !== 'undefined' && history.onChangeState) {
  history.onChangeState(
    [{ pathname: '/register.php' }],
    () => {
      // Mount the component when navigating to register
      PreauthButtonRenderer.mount();
    },
    () => {
      // Unmount when leaving register
      PreauthButtonRenderer.unmount();
    }
  );
}
